import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeLayoutComponent } from './home-layout/home-layout.component';
// import { ImportOrderComponent } from './orders/container/import-order/import-order.component';
import { auth2Guard } from './_guard/auth2.guard';
import { authGuard } from './_guard/auth.guard';
import { PagenotfoundComponent } from './shared/component/pagenotfound/pagenotfound.component';

const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: '',
    // canLoad: [auth2Guard],
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: '',
    component: HomeLayoutComponent,
    canActivate: [authGuard],
    children: [
      // {
      //   path: 'import-order',
      //   component: ImportOrderComponent,
      //   // canActivate: [AuthGuard],
      //   data: { title: 'Opollo WMS' }
      // },
      
      {
        path: 'access-management-services',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./module/access-management/access-management.module').then(m => m.AccessManagementModule)
      },
      
      {
        path: 'dashboardnm',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule)
      },
      {
        path: 'setting',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./setting/setting.module').then(m => m.SettingModule)
      },
      {
        path: 'utility',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./module/utility/utility.module').then(m => m.UtilityModule)
      },
      {
        path: 'account-configuration',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./module/account-configuration/account-configuration.module').then(m => m.AccountConfigurationModule)
      },
      {
        path: 'orders',
        loadChildren: () => import('./module/orders/orders/orders-routing.module').then(m => m.ordersRoutingModule)
      },
      {
        path: 'master',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./module/master/master/master.module').then(m => m.masterModule)
      },
      
      {
        path: 'dashboard',
        // canActivate: [auth2Guard],
        loadChildren: () => import('./module/analytics/analytics.module').then(m => m.AnalyticsModule)
      },
      {
        path: 'vendor',
        loadChildren: () => import('./module/vendors/vendors.module').then(m => m.VendorsModule)
      },
      {
        path: 'customers',
        loadChildren: () => import('./module/customers/customers.module').then(m => m.customersModule)
      },
      {
        path: 'associate',
        loadChildren: () => import('./module/associates/associates.module').then(m => m.associatesModule)
      },
      {
        path: 'wage',
        loadChildren: () => import('./module/wages/wage.module').then(m => m.wageModule)
      },
      {
        path: 'rule-engine',
        loadChildren: () => import('./module/rule-engine/rule-engine.module').then(m => m.RuleEngineModule)
      },
      {
        path: 'procurement',
        loadChildren: () => import('./module/procurement/procurement.module').then(m => m.ProcurementModule)
      },
      {
        path: 'warehouse-ops',
        loadChildren: () => import('./module/warehouse-ops/warehouse-ops.module').then(m => m.WarehouseOpsModule)
      },
      {
        path: 'wage-master',
        loadChildren: () => import('./module/wage-master/master/wage-master.module').then(m => m.wageMasterModule)
      },
    ]
  },
  { path: 'pageNotFound', component: PagenotfoundComponent},
  

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
